<div *ngIf="!isExamOnMobile()" class="question" [ngClass]="getAccentColor()">
  <div class="d-flex justify-content-between">
    <div class="d-md-none row mb-2">
      <h4>{{ getShortName() }}</h4>
      <h4>{{ getStage() }}</h4>
    </div>
    <h4 class="d-none d-md-block">{{ getFullType() }}</h4>
    <button
      type="button"
      class="btn btn-outline-primary rounded-pill btn-sm mb-3"
      (click)="instructionModal.show()"
    >
      <app-icon class="icon-blue" name="question-mark"></app-icon>
    </button>
  </div>
  <p class="text-muted xsmall d-none d-md-block">
    {{
      "EXERCISES.DETAILS.QUESTION_SET.DESCRIPTION." + getDescriptionCode()
        | translate
    }}
  </p>
  <div class="d-flex flex-column justify-content-md-between gap-2">
    <div class="row mb-2 me-md-3 g-2">
      <exercise-square
        *ngFor="let exercise of getExercises()"
        [availability]="getAvailability(exercise)"
        [exercise]="exercise"
        [section]="section"
        (openLockedExerciseSetModal)="lockedExerciseSetModal.show()"
        (openCompletedExamResultModal)="openCompletedExamResultModal($event)"
        class="col-auto"
      ></exercise-square>
    </div>
    <button
      type="button"
      class="d-flex flex-row btn btn-primary medium rounded-pill px-3 ms-auto align-items-center align-self-end"
      (click)="onContinue()"
    >
      {{ "BUTTON.CONTINUE" | translate }}
    </button>
  </div>
</div>


<app-instruction-modal
  #instructionModal
  [sectionPath]="section?.type"
  [exerciseName]="getShortName()"
  [showCompletedState]="hasCompletedRealExam()">
</app-instruction-modal>


<app-modal #lockedExerciseSetModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "EXERCISES.DETAILS.QUESTION_SET.LOCKED_PART_MODAL.TITLE" | translate }}</h5>
      <button type="button"
          class="btn btn-close btn-close-white"
          (click)="lockedExerciseSetModal.hide()"
          aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
        <div class="my-2">
            <span>{{ "EXERCISES.DETAILS.QUESTION_SET.LOCKED_PART_MODAL.INFO" | translate }}</span>
        </div>
    </div>
    </div>
</app-modal>

<app-modal #completedExamResultModal>
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "EXAM.COMPLETED_MODAL.TITLE" | translate }}</h5>
      <button type="button"
          class="btn btn-close btn-close-white"
          (click)="completedExamResultModal.hide()"
          aria-label="Close">
      </button>
    </div>
    <div class="modal-body completed-exam-modal-body">
      <ng-container *ngIf="!isCompletedExamResultLoading && !isCompletedExamResultError && completedExamSession; else noCompletedExamResult">
        <p class="mb-4">
          {{ "EXAM.SUMMARY.INFO_1" | translate: {stageName: completedExamSession?.chapterName} }}
        </p>
        <p class="mb-4">{{ "EXAM.COMPLETED_MODAL.INFO" | translate }}</p>
        <div class="table-responsive mb-2">
          <table class="table white-text table-borderless text-center">
            <thead>
            <tr class="table-row table-row-head">
              <th class="small">{{ 'EXAM.TABLE_HEADER.PART' | translate }}</th>
              <th class="small">{{ 'EXAM.TABLE_HEADER.TASK' | translate }}</th>
              <th class="small">{{ 'EXAM.TABLE_HEADER.SCORE' | translate }}</th>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr *ngFor="let part of completedExamSessionParts; index as i" class="table-row">
              <td class="small text-nowrap">{{ i + 1 }}</td>
              <td class="small">{{ part.partName }}</td>
              <td class="small">{{ part.score ? (part.score | percent:'1.0-0') : '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="bg-blue rounded-3 py-2 px-3 mb-4">
          <p class="mb-0">{{ "EXAM.SUMMARY.TOTAL_SCORE_INFO" | translate }} {{ (getCompletedExamTotalScore() | percent:'1.0-0') }}</p>
        </div>
        <hr class="text-primary my-4" />
        <h5 class="mt-4 mb-3">{{ "EXAM.SUMMARY.SCORE_INFO.TITLE" | translate }}</h5>
        <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getCompletedExamStageRange() + '.INFO_1' | translate }}</p>
        <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getCompletedExamStageRange() + '.INFO_2' | translate }}</p>
        <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getCompletedExamStageRange() + '.INFO_3' | translate }}</p>
        <p>{{ 'EXAM.SUMMARY.SCORE_INFO.' + getCompletedExamStageRange() + '.INFO_4' | translate }}</p>
        <hr class="text-primary my-4" />
        <p class="mb-0 bg-blue rounded-3 py-2 px-3">{{ "EXAM.SUMMARY.INFO_2" | translate }}</p>
      </ng-container>
      <ng-template #noCompletedExamResult>
        <p *ngIf="isCompletedExamResultLoading" class="my-2">{{ "EXAM.COMPLETED_MODAL.LOADING" | translate }}</p>
        <p *ngIf="!isCompletedExamResultLoading" class="my-2">{{ "EXAM.COMPLETED_MODAL.ERROR" | translate }}</p>
      </ng-template>
    </div>
  </div>
</app-modal>
